// extracted by mini-css-extract-plugin
module.exports = {"pay":"Pay-module__pay___3KJDW Buttons-module__sec___3tDVJ Fonts-module__bt___102gf"};